import { render, staticRenderFns } from "./ModalExperiencia.vue?vue&type=template&id=ec629988&scoped=true"
import script from "./ModalExperiencia.vue?vue&type=script&lang=js"
export * from "./ModalExperiencia.vue?vue&type=script&lang=js"
import style0 from "./ModalExperiencia.vue?vue&type=style&index=0&id=ec629988&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec629988",
  null
  
)

export default component.exports